export function makeParam(param?: string): string {
  return param ? param + '/' : ''
}
